import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "blue-label",
  "use": "blue-label-usage",
  "viewBox": "0 0 57 21",
  "content": "<symbol viewBox=\"0 0 57 21\" xmlns=\"http://www.w3.org/2000/svg\" id=\"blue-label\"><defs><linearGradient x1=\"100%\" y1=\"50%\" x2=\"0%\" y2=\"50%\" id=\"blue-label_a\"><stop stop-color=\"#2E8DFF\" offset=\"0%\" /><stop stop-color=\"#5BA6FF\" offset=\"100%\" /></linearGradient></defs><path d=\"M47.5 0A9.5 9.5 0 0 1 57 9.5a9.504 9.504 0 0 1-6.49 9.013c-2.06.844-5.161 1.63-9.304 2.355L43.214 19H9.5a9.5 9.5 0 0 1 0-19h38z\" fill=\"url(#blue-label_a)\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol